export enum TipoEventoEnum {
    NOTIFICA = <any>"NOTIFICA",
    AGGIORNAMENTO = <any>"AGGIORNAMENTO",
    CONTATORE = <any>"CONTATORE",
}
